import type { ReactNode } from "react";
import { Icon, type IconName } from "@/components/ui/Icon";

interface MetaChipProps {
  icon?: IconName;
  children: ReactNode;
}

/** Small pill for header metadata: cadence, participant/protocol counts,
 * time-of-day, ISO week — the row of chips under a `ProtokolleHeader` title. */
export function MetaChip({ icon, children }: MetaChipProps) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: "var(--surface-soft)",
        border: "1px solid var(--hairline)",
        borderRadius: 8,
        padding: "5px 11px",
        fontSize: 13,
        color: "var(--ink-2)",
        lineHeight: 1.3,
      }}
    >
      {icon ? <Icon name={icon} size={14} color="var(--ink-2)" /> : null}
      {children}
    </span>
  );
}
